import React from 'react';
import Logo from './Logo';
import PropTypes from 'prop-types';

function ChatMessage({ role, text }) {
  const isUser = role === 'user';
  const isBot = role === 'assistant';

  // Format text for better readability
  const formatText = (text) => {
    if (!text) return '';
    
    // Split by double newlines for paragraphs
    const paragraphs = text.split('\n\n');
    
    return paragraphs.map((paragraph, pIndex) => {
      // Check if paragraph contains bullet points
      const lines = paragraph.split('\n');
      const hasBullets = lines.some(line => line.trim().match(/^[•\-\*]\s/));
      
      if (hasBullets) {
        // Format as bullet list
        return (
          <div key={pIndex} style={{ marginBottom: pIndex < paragraphs.length - 1 ? '1rem' : '0' }}>
            {lines.map((line, lIndex) => {
              const trimmedLine = line.trim();
              if (trimmedLine.match(/^[•\-\*]\s/)) {
                return (
                  <div key={lIndex} style={{ 
                    display: 'flex', 
                    alignItems: 'flex-start', 
                    marginBottom: '0.5rem',
                    paddingLeft: '0.5rem'
                  }}>
                    <span style={{ marginRight: '0.5rem', color: isUser ? 'rgba(255,255,255,0.8)' : '#bada55' }}>•</span>
                    <span>{trimmedLine.replace(/^[•\-\*]\s/, '')}</span>
                  </div>
                );
              } else if (trimmedLine) {
                return <div key={lIndex} style={{ marginBottom: '0.5rem' }}>{trimmedLine}</div>;
              }
              return null;
            })}
          </div>
        );
      } else {
        // Format as regular paragraph
        return (
          <div key={pIndex} style={{ 
            marginBottom: pIndex < paragraphs.length - 1 ? '1rem' : '0',
            lineHeight: '1.5'
          }}>
            {paragraph.split('\n').map((line, lIndex) => (
              <div key={lIndex}>{line || <br />}</div>
            ))}
          </div>
        );
      }
    });
  };

  return (
    <div className="message-group" style={{ 
      flexDirection: isUser ? 'row-reverse' : 'row',
      marginBottom: '1rem'
    }}>
      {isBot && (
        <div className="robot-avatar">
                      <Logo size="1.2rem" />
        </div>
      )}
      
      <div 
        className={`message-bubble ${role}`}
        style={{
          background: isUser ? '#f4ffa9' : 'var(--color-bot-bg)',
          color: isUser ? '#133153' : 'var(--color-dark)',
          marginLeft: isUser ? 'auto' : '0',
          marginRight: isUser ? '0' : 'auto',
          borderBottomLeftRadius: isBot ? '8px' : '20px',
          borderBottomRightRadius: isUser ? '8px' : '20px',
          maxWidth: '75%',
          padding: '1rem 1.25rem',
          borderRadius: '20px',
          fontSize: '15px',
          lineHeight: '1.4',
          wordWrap: 'break-word',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
        }}
      >
        {formatText(text)}
      </div>
    </div>
  );
}

ChatMessage.propTypes = {
  role: PropTypes.oneOf(['user', 'assistant']).isRequired,
  text: PropTypes.string.isRequired,
};

export default ChatMessage; 